export default __webpack_public_path__ + "static/media/bmp.199df4bc.svg";